/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-notification-off-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 11V8.125a6.25 6.25 0 00-.681-2.813l3.181-3.18-.881-.882L1.25 17.869l.881.881 3.125-3.125h1.619a3.125 3.125 0 006.25 0H17.5a.587.587 0 00.625-.625v-1.875a.569.569 0 00-.188-.438L16.25 11zM10 17.5a1.875 1.875 0 01-1.875-1.875h3.75c0 1.036-.84 1.875-1.875 1.875zm3.519-14.55a6.113 6.113 0 00-2.894-1.075V.625h-1.25v1.25a6.344 6.344 0 00-5.625 6.25V11l-1.688 1.688a.569.569 0 00-.187.437v1.463L13.519 2.95z"/>'
  }
})
